/* alphanum.js (C) Brian Huisman
 * Based on the Alphanum Algorithm by David Koelle
 * The Alphanum Algorithm is discussed at http://www.DaveKoelle.com
 *
 * Distributed under same license as original
 *
 * Released under the MIT License - https://opensource.org/licenses/MIT
 */

/**
 * Sort alphanumerical values if provided as compareFunction to the
 * [Array.prototype.sort()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort) method
 * @see http://www.davekoelle.com/files/alphanum.js
 * @param {*} a The first element for comparison.
 * @param {*} b The second element for comparison.
 */
export function alphanum(a, b) {
  function chunkify(t) {
    var tz = new Array();
    var x = 0,
      y = -1,
      n = 0,
      i,
      j;

    while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
      var m = i == 46 || (i >= 48 && i <= 57);
      if (m !== n) {
        tz[++y] = '';
        n = m;
      }
      tz[y] += j;
    }
    return tz;
  }

  var aa = chunkify(a);
  var bb = chunkify(b);

  for (let x = 0; aa[x] && bb[x]; x++) {
    if (aa[x] !== bb[x]) {
      var c = Number(aa[x]),
        d = Number(bb[x]);
      if (c == aa[x] && d == bb[x]) {
        return c - d;
      } else return aa[x] > bb[x] ? 1 : -1;
    }
  }
  return aa.length - bb.length;
}
